export const fileSaver = (data: Blob, fileName: string): void => {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(
    new Blob([data], { type: 'application/octet-stream' }),
  ).toString();
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
